import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { NbMenuService } from '@nebular/theme';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable()
export class NotAuthenticationGuard {
	constructor(
		private authService: NbAuthService,
		private menuService: NbMenuService
	) {}

	canActivate(): Observable<boolean> {
		return this.authService.isAuthenticated().pipe(
			map((authenticated: boolean) => {
				if (authenticated) {
					this.menuService.navigateHome();
					return false;
				}
				return true;
			}),
			take(1)
		);
	}
}
